
import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

@Component({
  name: 'Profile',
  computed: {
    ...mapGetters('process', ['getProcessName'])
  }
})
export default class Profile extends Vue {
  private saveButtonDisabled: boolean = false;
  getProcessName!: string;

  get navigationLinks () {
    let routes = [
      {to: {name: 'profile-info'}, label: this.$tr('profile.title')},
      {to: {name: 'profile-notifications'}, label: this.$tr('profile.notifications.title')},
      {to: {name: 'profile-password'}, label: this.$tr('profile.password.title')}
    ]

    if (this.getProcessName === 'sportmaster') {
      routes.push({ to: { name: 'profile-shop'}, label: 'Дополнительно' })
    }

    return routes
  };
  get unsaved_changes() {
    return this.$store.getters['user/change_user'];
  };

  public changeSaveButton (val) {
    this.saveButtonDisabled = val
  };

  public save () {
    this.$emit('save')
    // this.$store.dispatch('usernew/save')
  };

  public can_go() {
    return this.unsaved_changes ? window.confirm(this.$tr('vacancy.preferences.modals.leaveUnsavedData')) : false
  };

  public reset_change() {
    this.$store.commit('user/set_change_user', false);
  };

  beforeRouteUpdate (to, from, next) {
    if (this.unsaved_changes) {
      if (this.can_go()) {
        this.reset_change()
        next()
        window.onbeforeunload = null
      } else {
        next(false)
      }
    } else {
      next()
      window.onbeforeunload = null
    }
  };

  beforeRouteLeave (to, from, next) {
    if (this.unsaved_changes) {
      if (this.can_go()) {
        this.reset_change()
        next()
        window.onbeforeunload = null
      } else {
        next(false)
      }
    } else {
      next()
      window.onbeforeunload = null
    }
  };
}
